<template>
  <article class="post" :class="{ 'post-detail-expanded': expanded }">
    <div class="inner" :class="{ 'post-detail-inner': expanded }">
      <p class="meta">
        <time :pubdate="blogpost.fields.pub_date" >{{$options.filters.date(blogpost.fields.pub_date, '%w')| toWeekDay}},</time>
        <time :pubdate="blogpost.fields.pub_date" :data-updated="blogpost.fields.last_edit_date"
              v-text="$options.filters.date(blogpost.fields.pub_date, '%b')+' '+
              $options.filters.date(blogpost.fields.pub_date, '%d')+ ','+
              $options.filters.date(blogpost.fields.pub_date, '%Y') + ' at '+
              $options.filters.date(blogpost.fields.pub_date, '%T')"
        >
        </time>
      </p>
      <header class="post-header">
        <h2 class="post-title"><router-link :to="{ name: 'postDetail', params: {url : blogpost.url}}">{{ blogpost.fields.title }}</router-link></h2>
        <div class="clear"></div>
      </header>

      <section class="post-excerpt">
        <div v-if="expanded" class="post-content" v-html="contentHtml"></div>
        <span v-else @click="allRender">
         <read-more more-str="阅读更多" less-str="收起" :text="blogpost.content" link="#" :max-chars="4500"></read-more>
        </span>
      </section>
      <footer class="post-meta">
        <img class="author-thumb" src="../assets/images/ccx_2.jpeg" alt="Changxin Cheng" nopin="nopin" />
        <router-link :to="{ name: 'profile'}">Changxin Cheng</router-link>
        posted in
        <tag-item
         v-for="tag in blogpost.tags"
         v-bind:key = "tag.pk"
         v-bind:tag = "tag"
        />
        <time class="post-date" :pubdate="blogpost.fields.pub_date" :data-updated="blogpost.fields.last_edit_date" v-text="$options.filters.date(blogpost.fields.pub_date, '%b') +' '+$options.filters.date(blogpost.fields.pub_date, '%d')+ ','+ $options.filters.date(blogpost.fields.pub_date, '%Y') ">
        </time>
      </footer>
    </div>
  </article>
</template>

<script>
  import tagItem from './TagItem'
  export default {
  name: 'blog-post',
  components: {
    tagItem
  },
  data () {
    return {
    }
  },
  props: {
    blogpost: {
      type: Object,
      // required: false
      required: true
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    contentHtml() {
      return this.blogpost.content || this.blogpost.fields.body || ''
    }
  },
  methods: {
    reRender() {
      if(window.MathJax) {
        console.log('rendering mathjax');
        window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log('done'));
      }
    },
    uml(){
      $("code").each(function() {
        var uml_index = $(this).text().indexOf("@startuml")
        if(uml_index>-1){
          var src = "//www.plantuml.com/plantuml/img/" + window.plantumlEncoder.encode( $(this).text() )
          $(this).replaceWith($('<img>').attr('src', src));
        }
      });
    },
    allRender(){
        this.reRender()
        this.uml()
      }

  },
  watch: {
    blogpost: function() {
      console.log('blogpost changed')
      this.reRender();
    }
  },
  mounted() {
    this.reRender()
    this.uml()
  },
}
</script>

<style scoped>
  .post-header {
    margin-bottom: 25px;
  }

  .author-thumb {
    width: 24px;
    height: 24px;
    float: left;
    margin: auto;
    padding: 3px;
    border-radius: 100%;
    margin-top: -5px;
  }

  .post-date {
    display: inline-block;
    margin-left: 8px;
    padding-left: 12px;
    border-left: #d5dbde 1px solid;
    text-transform: uppercase;
    font-size: 1.3rem;
    white-space: nowrap;
  }

  .post-title h2 {
  font-size: 2.0em;
  }

  .post-excerpt {
  font-size: 0.8em;
  }

  .container .post {
  padding: 1.5em 0;
  }

  .post-meta {
  margin: 1.334em 0;
  }

  .post-detail-expanded {
  max-width: 1120px;
  width: 86%;
  margin-left: auto;
  margin-right: auto;
  }

  .post-detail-inner {
  max-width: 1120px;
  width: 100%;
  }

  .post-detail-inner > .meta,
  .post-detail-inner > .post-header,
  .post-detail-inner > .post-excerpt,
  .post-detail-inner > .post-meta {
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;
  }

</style>

<style>
  .post-detail-expanded .post-content {
  padding-top: 0;
  }

  .post-detail-expanded .post-content > * {
  min-width: 0;
  width: 100%;
  }
</style>
